<div
  class="form-field"
  [class.submitting]="submitting()"
  [class.error]="errorType() === 'outline' && error() && !isDisabled()"
  [class.disabled]="isDisabled()"
  [class.form-field--input-icon]="copy() || icon()"
  [style.--copy-icon-color]="copy()?.iconColor ?? 'var(--yellow)'"
  [style.--copy-icon-opacity]="copy()?.iconOpacity ?? '1'"
>
  @if (label()) {
  <label [for]="id()">{{ label() }}</label>
  } @if (copy()) {
  <div class="input-container copy-container">
    <input
      [id]="id()"
      [type]="type()"
      [placeholder]="placeholder()"
      required
      [(ngModel)]="value"
      [disabled]="isDisabled()"
      (input)="onInput($event)"
      [attr.maxlength]="maxlength() ?? null"
      [attr.step]="step()"
      [required]="required()"
    />
    <button
      type="button"
      class="w-34 flex items-center justify-end"
      (click)="clipboardService.copy(value(), copy()?.successMessage)"
    >
      <svg-icon
        src="assets/icons/ui/copy.svg"
        class="s-16 flex items-center justify-center"
      />
    </button>
  </div>
  } @else if (icon()) {
  <div class="input-container">
    <svg-icon [src]="icon()!" class="s-16 flex items-center justify-center" />
    <input
      [id]="id()"
      [type]="type()"
      [placeholder]="placeholder()"
      required
      [(ngModel)]="value"
      [disabled]="isDisabled()"
      (input)="onInput($event)"
      [attr.maxlength]="maxlength() ?? null"
      [attr.step]="step()"
      [required]="required()"
    />
  </div>
  } @else {
  <input
    [id]="id()"
    [type]="type()"
    [placeholder]="placeholder()"
    required
    [(ngModel)]="value"
    [disabled]="isDisabled()"
    (input)="onInput($event)"
    [attr.maxlength]="maxlength() ?? null"
    [attr.step]="step()"
    [required]="required()"
  />
  }

  <!--  -->

  @if (errorType() === 'text-bottom') {
  <p [class.error]="error() && !isDisabled()">
    @if (typeof error() === 'string') {
    {{ error() }}
    } @else {
    {{ "Field is required" }}
    }
  </p>
  }
</div>
